import { updateBook } from "../actions";

const updatedBook = (book) => async (dispatch) => {
  const URL = `https://assignment4-bookstore-server-tanviranindo.glitch.me/books/${book.id}`;

  const response = await fetch(URL, {
    method: "PATCH",
    headers: { "Content-Type": "application/json; charset=UTF-8" },
    body: JSON.stringify({ ...book, price: book.price, rating: book.rating })
  });

  const updatedBooks = await response.json();

  if (response.status === 200) {
    dispatch(updateBook(updatedBooks));
  }
};

export default updatedBook;
